var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasPageThanks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 226,
    viewBox: "0 0 178 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_17571)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 160,
    height: 208,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 11V10.9979C168.495 9.69855 167.774 8.56446 166.695 7.77225C165.616 6.97982 164.15 6.50364 162.553 6.5H162.552L15.4483 6.5L15.4471 6.5C13.8498 6.50364 12.3843 6.97982 11.3049 7.77225C10.2259 8.56447 9.50549 9.69856 9.5 10.9979H9.5V11V23V23.5H10H168H168.5V23V11Z",
    fill: "#E5E8F5",
    stroke: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.2402H24V18.4802H18V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12.2402H34V18.4802H28V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 12.2402H44V18.4802H38V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 12.2402H113V18.4802H58V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 155,
    width: 120,
    height: 18,
    rx: 3,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 100,
    width: 122,
    height: 8,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 116,
    width: 122,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 129,
    width: 67,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 180,
    width: 122,
    height: 22,
    rx: 4,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1953 195V187H73.3984C73.987 187 74.4779 187.087 74.8711 187.262C75.2643 187.436 75.5599 187.678 75.7578 187.988C75.9557 188.296 76.0547 188.65 76.0547 189.051C76.0547 189.363 75.9922 189.638 75.8672 189.875C75.7422 190.109 75.5703 190.302 75.3516 190.453C75.1354 190.602 74.888 190.707 74.6094 190.77V190.848C74.9141 190.861 75.1992 190.947 75.4648 191.105C75.7331 191.264 75.9505 191.487 76.1172 191.773C76.2839 192.057 76.3672 192.396 76.3672 192.789C76.3672 193.214 76.2617 193.592 76.0508 193.926C75.8424 194.257 75.5339 194.518 75.125 194.711C74.7161 194.904 74.2122 195 73.6133 195H70.1953ZM71.8867 193.617H73.2656C73.737 193.617 74.0807 193.527 74.2969 193.348C74.513 193.165 74.6211 192.923 74.6211 192.621C74.6211 192.4 74.5677 192.204 74.4609 192.035C74.3542 191.866 74.2018 191.733 74.0039 191.637C73.8086 191.54 73.5755 191.492 73.3047 191.492H71.8867V193.617ZM71.8867 190.348H73.1406C73.3724 190.348 73.5781 190.307 73.7578 190.227C73.9401 190.143 74.0833 190.026 74.1875 189.875C74.2943 189.724 74.3477 189.543 74.3477 189.332C74.3477 189.043 74.2448 188.81 74.0391 188.633C73.8359 188.456 73.5469 188.367 73.1719 188.367H71.8867V190.348ZM84.8193 191C84.8193 191.872 84.654 192.615 84.3232 193.227C83.9951 193.839 83.5472 194.306 82.9795 194.629C82.4144 194.949 81.779 195.109 81.0732 195.109C80.3623 195.109 79.7243 194.948 79.1592 194.625C78.5941 194.302 78.1475 193.835 77.8193 193.223C77.4912 192.611 77.3271 191.87 77.3271 191C77.3271 190.128 77.4912 189.385 77.8193 188.773C78.1475 188.161 78.5941 187.695 79.1592 187.375C79.7243 187.052 80.3623 186.891 81.0732 186.891C81.779 186.891 82.4144 187.052 82.9795 187.375C83.5472 187.695 83.9951 188.161 84.3232 188.773C84.654 189.385 84.8193 190.128 84.8193 191ZM83.1045 191C83.1045 190.435 83.0199 189.958 82.8506 189.57C82.6839 189.182 82.4482 188.888 82.1436 188.688C81.8389 188.487 81.4821 188.387 81.0732 188.387C80.6644 188.387 80.3076 188.487 80.0029 188.688C79.6982 188.888 79.4613 189.182 79.292 189.57C79.1253 189.958 79.042 190.435 79.042 191C79.042 191.565 79.1253 192.042 79.292 192.43C79.4613 192.818 79.6982 193.112 80.0029 193.312C80.3076 193.513 80.6644 193.613 81.0732 193.613C81.4821 193.613 81.8389 193.513 82.1436 193.312C82.4482 193.112 82.6839 192.818 82.8506 192.43C83.0199 192.042 83.1045 191.565 83.1045 191ZM85.4023 188.395V187H91.9727V188.395H89.5234V195H87.8516V188.395H85.4023ZM93.4561 195H91.6436L94.4053 187H96.585L99.3428 195H97.5303L95.5264 188.828H95.4639L93.4561 195ZM93.3428 191.855H97.624V193.176H93.3428V191.855ZM94.374 186.211L93.4521 186.199C93.4521 185.702 93.5745 185.32 93.8193 185.055C94.0641 184.789 94.3649 184.655 94.7217 184.652C94.904 184.652 95.0602 184.682 95.1904 184.742C95.3206 184.799 95.4391 184.867 95.5459 184.945C95.6527 185.023 95.7542 185.092 95.8506 185.152C95.9469 185.21 96.0511 185.238 96.1631 185.238C96.3141 185.236 96.4287 185.18 96.5068 185.07C96.5876 184.958 96.6279 184.812 96.6279 184.633L97.5381 184.66C97.5329 185.152 97.4079 185.533 97.1631 185.801C96.9183 186.066 96.6188 186.201 96.2646 186.203C96.0719 186.206 95.9092 186.177 95.7764 186.117C95.6462 186.057 95.5316 185.99 95.4326 185.914C95.3337 185.836 95.2373 185.767 95.1436 185.707C95.0498 185.647 94.9443 185.617 94.8271 185.617C94.6917 185.617 94.5824 185.671 94.499 185.777C94.4157 185.884 94.374 186.029 94.374 186.211ZM107.281 191C107.281 191.872 107.116 192.615 106.785 193.227C106.457 193.839 106.009 194.306 105.441 194.629C104.876 194.949 104.241 195.109 103.535 195.109C102.824 195.109 102.186 194.948 101.621 194.625C101.056 194.302 100.609 193.835 100.281 193.223C99.9531 192.611 99.7891 191.87 99.7891 191C99.7891 190.128 99.9531 189.385 100.281 188.773C100.609 188.161 101.056 187.695 101.621 187.375C102.186 187.052 102.824 186.891 103.535 186.891C104.241 186.891 104.876 187.052 105.441 187.375C106.009 187.695 106.457 188.161 106.785 188.773C107.116 189.385 107.281 190.128 107.281 191ZM105.566 191C105.566 190.435 105.482 189.958 105.312 189.57C105.146 189.182 104.91 188.888 104.605 188.688C104.301 188.487 103.944 188.387 103.535 188.387C103.126 188.387 102.77 188.487 102.465 188.688C102.16 188.888 101.923 189.182 101.754 189.57C101.587 189.958 101.504 190.435 101.504 191C101.504 191.565 101.587 192.042 101.754 192.43C101.923 192.818 102.16 193.112 102.465 193.312C102.77 193.513 103.126 193.613 103.535 193.613C103.944 193.613 104.301 193.513 104.605 193.312C104.91 193.112 105.146 192.818 105.312 192.43C105.482 192.042 105.566 191.565 105.566 191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 42,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#4C6FFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 38,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#4C6FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5 55L84 69.7999L80 62",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 6.5,
    width: 159,
    height: 207,
    rx: 5.5,
    stroke: "#D0D4E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_17571",
    x: 0,
    y: 0,
    width: 178,
    height: 226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_26_17571"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_17571"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_17571",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasPageThanks);
export default __webpack_public_path__ + "static/media/canvas_page_thanks.6c17af467de0fcace5e081b7ff4150bd.svg";
export { ForwardRef as ReactComponent };